<template>
  <div class="page page-designs">
    <div class="page-title" v-if="page.header">
      <HTMLDisplay :item="page.header" :content="page.header.content"/>
    </div>
    <div class="playbook-page-content" v-if="page.columns && page.columns.length">
      <div class="product-container" v-for="(item, index) in totalDesigns.slice(0,4)" :key="index">
        <Product  
      
            :product="item.product"
            :originalProduct="item.product"
            :content="item.content"
            :withDescription="false"
            :readOnly="readOnly"
            :withProductGrid="false"
            :withImage="true"
            :pageType="'Designs'"
            :isPreviewMode="true"
            :isPlaybookDesignPage="true"
            
          />
          
      </div>
    </div>
    <div class="playbook-page-content playbook-page-content-missing" v-else>
      <MissingProduct :msg="'Missing product designs'" />
    </div>
    <div class="more-designs" v-if="totalDesigns.length > 4" @click="openDesignsModal()">
        <button type="button" class="btn black-btn"> more designs available</button>
    </div>
    <div class="page-footer" v-else-if="page.footer">
      <HTMLDisplay :item="page.footer" :content="page.footer.content"/>
    </div>

    <div class="page-number-count" :class="{ 'right-page-number': (pageId % 2 === 0) }">
      {{ pageId }}
    </div>
  </div>
</template>

<script>
import HTMLDisplay from "@/components/Projects/Playbooks/HTMLDisplay.vue";
//import PageColumnItem from "@/components/Projects/Playbooks/PageColumnItem.vue";
import Product from "@/components/Projects/Product/Product.vue";
import MissingProduct from "@/components/Projects/Playbooks/MissingProduct.vue";
import { mapActions } from 'vuex';

export default {
  name: "Designs",
  props: {
    page: {
      type: Object,
    },
    pageId: {
      type: Number,
    },
    layoutOverride: {
      type: [Object],
    },
    anonymousCrossOrigin: {
      type: Boolean,
    },
    readOnly: {
      type: Boolean
    },
  },
  computed: {

    totalDesigns() {
      return this.page.columns.map((col) => {
        return col
      }).flat(1)
    }
  },

  methods: {

    ...mapActions("project", ["setDesignsModalProduct"]),
    openDesignsModal() {
      if(this.readOnly) return false
      this.setDesignsModalProduct(this.totalDesigns)
    },

  },

  components: {
    HTMLDisplay,
   // PageColumnItem,
    MissingProduct,
    Product
  },
};
</script>

<style lang="scss" scoped>
#app {
  .page-designs {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .playbook-page-content {
      max-height: 75%;
      flex-wrap: wrap;
      .product-container {
        width: 100%;
        height: 30em;
        max-width: 50%;
        max-height: 50%;
        .product-info .grid-title-container .grid-title.with-background {
          margin-bottom: 0 !important;
        }
      }
      &.playbook-page-content-missing {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .playbook-page-column-3 {
      width: 33% !important;
    }

    .page-title, .page-footer {
      height: 25%;
    }

    .page-footer {
      align-items: flex-end;
      display: flex;
    }

    .btn {
          color: #000;
    font-size: 1em;
    line-height: 1em;
    letter-spacing: 0.91px;
    padding: 0.75em 1.25em;
    border-radius: 109px;
    border: 1px solid #000;
    text-decoration: none;
    text-transform: uppercase;
    text-align: center;
    cursor: pointer;
      &.black-btn {
        color: #fff;
        background-color: #000;
        border-color: #fff;
        &:hover {
          color: #000;
          background-color: #fff;
          border-color: #000;
        }
      }
    }

    .more-designs {
      z-index: 1;
      text-transform: uppercase;
      text-align: center;
      cursor: pointer;
      height: 25%;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        padding: 1em;
        border: 3px solid $darkGray;
        color: $darkGray;
        
      } 
    }
  }
}
</style>